function n(a) {
  return { aliases: ["pycon"], contains: [{ className: "meta.prompt", starts: { end: / |$/, starts: { end: "$", subLanguage: "python" } }, variants: [{ begin: /^>>>(?=[ ]|$)/ }, { begin: /^\.\.\.(?=[ ]|$)/ }] }] };
}
export {
  n as default
};
